import { Checkbox as MantineCheckbox, type CheckboxProps as MantineCheckboxProps } from '@mantine/core'

export interface CheckboxProps extends MantineCheckboxProps {
  label: string
}

export function Checkbox({ label, ...props }: Readonly<CheckboxProps>) {
  return <MantineCheckbox {...props} label={label} />
}
